
import React from 'react';

function Unauthorized(props = {}) {
    return <span>
       You are not authorized to see this page!
    </span>
}

export default Unauthorized